<template>
    <div>
        <div class="userDatatable userDatatable--ticket userDatatable--ticket--2 mt-1 mb-3">
            <div class="table-responsive">
                <table class="table mb-0 table-borderless">
                    <thead>
                        <tr class="userDatatable-header">
                            <th>
                                <span class="userDatatable-title">ID</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Nama Shop</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Slug</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Custom Domain</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Status</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Actions</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="shop in shops" :key="shop.id">
                            <td>{{ shop.id }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <img 
                                        v-if="shop.logo_url" 
                                        :src="shop.logo_url" 
                                        alt="Logo" 
                                        style="width: 40px; height: 40px; border-radius: 8px; margin-right: 10px; object-fit: cover;"
                                    />
                                    <span>{{ shop.name }}</span>
                                </div>
                            </td>
                            <td>
                                <code>{{ shop.slug }}</code>
                            </td>
                            <td>{{ shop.custom_domain || '-' }}</td>
                            <td>
                                <span :class="shop.status === 'active' ? 'badge badge-success' : 'badge badge-danger'">
                                    {{ shop.status }}
                                </span>
                            </td>
                            <td>
                                <div class="action-btn d-flex flex-wrap" style="gap:4px">
                                    <a :href="'/toko/' + shop.slug" target="_blank" class="btn btn-sm btn-light" title="Lihat Public">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                    <router-link :to="'/shop/' + shop.id + '/dashboard'" class="btn btn-sm btn-primary" title="Dashboard">
                                        <i class="fas fa-tachometer-alt"></i>
                                    </router-link>
                                    <button @click="$emit('view-detail', shop.id)" class="btn btn-sm btn-info" title="Detail / Produk / Order">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                    <router-link :to="'/shop/' + shop.id + '/templates'" class="btn btn-sm btn-secondary" title="Template Pesan">
                                        <i class="fas fa-comment-dots"></i>
                                    </router-link>
                                    <router-link :to="'/shop/' + shop.id + '/categories'" class="btn btn-sm btn-secondary" title="Kategori">
                                        <i class="fas fa-tags"></i>
                                    </router-link>
                                    <router-link :to="'/shop/' + shop.id + '/broadcast'" class="btn btn-sm btn-warning" title="Broadcast">
                                        <i class="fas fa-bullhorn"></i>
                                    </router-link>
                                    <router-link :to="'/shop/' + shop.id + '/reports'" class="btn btn-sm btn-success" title="Laporan">
                                        <i class="fas fa-chart-line"></i>
                                    </router-link>
                                    <router-link :to="'/shop/' + shop.id + '/notification-log'" class="btn btn-sm btn-info" title="Log Notif">
                                        <i class="fas fa-history"></i>
                                    </router-link>
                                    <router-link :to="'/shop/' + shop.id + '/settings'" class="btn btn-sm btn-dark" title="Settings">
                                        <i class="fas fa-cog"></i>
                                    </router-link>
                                    <button @click="$emit('delete-shop', shop.id)" class="btn btn-sm btn-danger" title="Hapus">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="shops.length === 0">
                            <td colspan="6" class="text-center py-4">
                                <i class="fas fa-store fa-2x text-muted mb-2"></i>
                                <p class="text-muted">Belum ada shop. Klik tombol "Tambah Shop" untuk membuat shop pertama.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShopTable',
        data() {
            return {
                shops: []
            };
        },
        mounted() {
            this.loadShops();
            this.$root.$on('refresh-shop-table', this.loadShops);
        },
        beforeDestroy() {
            this.$root.$off('refresh-shop-table', this.loadShops);
        },
        methods: {
            async loadShops() {
                try {
                    const response = await this.$store.dispatch('shop/shop_list', {
                        limit: 100,
                        page: 1
                    });
                    this.shops = response.data.data.shops || [];
                } catch (error) {
                    console.error('Error loading shops:', error);
                    this.shops = [];
                }
            }
        }
    };
</script>

